"use client";
import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { EASINGS } from './_utils.js';

const variants = {
    exit: {
        opacity: 0,
        transition: {
            duration: 0.15,
            ease: EASINGS.easeOut,
        },
    },
    enter: {
        opacity: 1,
        transition: {
            duration: 0.2,
            ease: EASINGS.easeIn,
        },
    },
};
const fadeConfig = {
    variants,
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
};
const Fade = React.forwardRef((props, ref) => {
    const { unmountOnExit, visible, ...rest } = props;
    const show = unmountOnExit ? visible && unmountOnExit : true;
    const motionProps = React.useMemo(() => ({
        ...fadeConfig,
        animate: visible || unmountOnExit ? 'enter' : 'exit',
    }), [visible, unmountOnExit]);
    return React.createElement(AnimatePresence, null, show && React.createElement(motion.div, { ref: ref, ...motionProps, ...rest }));
});
Fade.displayName = 'Fade';

export { Fade, fadeConfig };
//# sourceMappingURL=Fade.js.map
